
import makerjs from "makerjs";
function B44(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,
    // L = Param[1].param,R = Param[2].param,T = Param[3].param,S1 = Param[4].param, 
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,
       b = B * 1 * myZoom,       
       h = b,
       w = b,
       r=b,
       x=r,y=r,glassH = h, glassW = w;
   if (b !== 0) {
       var TxtB ="B="+ B;
   } 
   var drawAbnormalShapeB44 = {
       paths: {
        "DnLine": new makerjs.paths.Line([0, 0], [b,0]),
        "RightLine": new makerjs.paths.Line([b, 0], [b,b]),
        "LeftLine": new makerjs.paths.Arc([b, b],[0, 0], b,false,false),
       }
   };
   var drawAbnormalShapeB44MarkB = {
       paths: {
        "bottomLine": new makerjs.paths.Line([0, -markShift], [b, -markShift]),        
        "RightShortUpline": new makerjs.paths.Line([0, 0], [0, -3*markShift]),
        "RightShortDnline": new makerjs.paths.Line([b, 0], [b, -3*markShift]),
       }  
   };
   makerjs.model.addCaption(drawAbnormalShapeB44MarkB, TxtB,  [0,-2*markShift], [b, -2*markShift]);//长度文字
   
  plate={
    models: {
      drawAbnormalShapeB44: drawAbnormalShapeB44,
      }
    };
  markers={
      models: {
        drawAbnormalShapeB44: drawAbnormalShapeB44,
        drawAbnormalShapeB44MarkB:drawAbnormalShapeB44MarkB,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B44;